// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__v0lo5","feature":"Slider_feature__k2pj3","mobile":"Slider_mobile__I2wD_","largeCard":"Slider_largeCard__Wl2Sq"};